<template>
  <div>
    <b-card-body>
      <b-card class="ConfigContainer">
        <div>
          <div class="ref-select referenceInfoYear">
            <p class="mr-2 yearText noselect">Ano Base</p>
            <b-form-select v-model="yearSelected" class="select-view noselect">
              <template #first>
                <b-form-select-option :value="null">Selecione o ano</b-form-select-option>
              </template>
              <b-form-select-option v-for="year in years" :key="year.id" :value="year.baseYear">{{ year.baseYear
              }}</b-form-select-option>
            </b-form-select>
          </div>
          <div class="tableSection">
            <b-row v-if="loaded">
              <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
                <table class="table table-hover table-sm">

                  <thead class="thead-dark">
                    <th scope="col">Área</th>
                    <th scope="col"> Denominador Comum </th>
                    <th scope="col"> Fator </th>
                  </thead>

                  <template v-if="json.length == 0">Sem dados para visualização<br></template>
                  <tbody v-else>

                    <tr v-for="item in json" :key="item.id">
                      <td class="text-truncate tableTxt" style="max-width: 250px; text-overflow: ellipsis">
                        {{ item.item }}
                      </td>
                      <td class="text-truncate tableTxt" style="max-width: 250px; text-overflow: ellipsis">

                        <select v-model="item.value">
                          <option v-for="op in tempJson" :key="op.name" :value="op.value"
                            :selected="item.value === op.value">
                            <span>{{ op.name }}</span>
                          </option>
                        </select>

                      </td>
                      <td class="text-truncate tableTxt">
                        <input class='input-coefficient' type="number" min="0" v-model="item.coefficient">
                      </td>
                    </tr>

                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row v-else-if="yearSelected == null" class="waitTxt rowDistance">
              Selecione ano base ...
            </b-row>
            <b-row v-else class="waitTxt rowDistance">Aguardando banco de dados ...</b-row>
          </div>
        </div>
        <hr>
        <div class="groupBtn">

          <img id="addLtConfig" class="float-right" src="@/assets/salvar.png" style="margin-left: 30px;"
            title="Salvar configuração" alt="confirmar" @click="mandaJson()" />

          <img id="" src="@/assets/cancel.png" style="margin-left: 30px;   max-height: 35px;" title="Recarregar Campos"
            alt="Recarregar Campos" @click="eraseForm()" />
        </div>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { urlMainAPI, defaultSuccess } from "@/global";
import axios from "axios";

export default {
  name: "LTconfiguratorBase",
  data: function () {
    return {
      json: [],
      tempJson: [],
      value: [],
      loaded: false,
      selected: null,
      num: 0,
      yearSelected: null,
      years: []
    }
  },

  watch: {
    async yearSelected(value) {
      await this.loadLt(value);
    }
  },

  methods: {
    async loadLt(year) {
      if (year != null) {
        defaultSuccess(this.$t('carregando-dados'));
        const url = `${urlMainAPI}/getltproductionplanitemlist/${year}`;
        await axios
          .get(url)
          .then((res) => {
            this.json = res.data.table;
            this.tempJson = res.data.variavel.map((x) => {
              return { name: x.name, value: x.id }
            })
            this.loaded = true
            defaultSuccess(this.$t('dados-carregados'));
          })
          .catch();
      }
    },

    mandaJson() {
      let obj = {}
      obj.table = this.json.map((item) => {
        return { area: item.item, variableId: item.value.toString(), coefficient: item.coefficient.toString() }
      })

      obj.baseYear = parseInt(this.yearSelected);

      defaultSuccess(this.$t('salvando'));
      const url = `${urlMainAPI}/saveltconfig`;
      axios
        .post(url, obj)
        .then(() => {
          defaultSuccess(this.$t('configuracao-da-lt-salva'));
        })
        .catch();

    },

    eraseForm() {
      this.loadLt()
    },

    async loadBaseYears() {
      const url = `${urlMainAPI}/getproductionplanswithrevisionsbyyear`;
      await axios
        .get(url)
        .then((res) => {
          this.years = res.data;
        })
        .catch();
    },
  },
  async created() {
    await this.loadBaseYears();
    this.loadLt(this.yearSelected)
  }
};
</script>

<style scoped>
.ConfigContainer {
  max-width: 800px;
  min-width: 350px;
  width: 800px;
}

.tableSection {
  margin: 10px;
  max-width: 550x;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin: 15px 5px 0 0;
}

.groupBtn img,
td>select {
  cursor: pointer;
}

td {
  padding: 2px 0 0 5px;
}

td>input {
  height: 25px;
}

.col1Header {
  max-width: 564px;
  text-align: center;
  background: black;
  color: white;
}

.groupRow3 {
  display: flex;
  flex-wrap: nowrap;
}

.tree-text {
  display: grid;
  font-family: Arial;
  font-size: 14pt;
  margin-right: 40px;
}

.input-coefficient {
  width: 100px;
}

.rootStyle {
  font-weight: 500;
}

.col1 {
  max-width: 600px;
}


.headerDash {
  display: grid;
  background-color: rgba(0, 0, 0);
  color: white;
  height: 24px;
}

#filter-tree {
  border: 2px solid black;
  border-radius: 4px;
}

.txtLimit {
  font-size: 0.8em;
}

img {
  max-height: 35px;
}

.treeMapSection {
  max-height: 200px;
  overflow: auto;
  margin: 0px auto;
}


table {
  border-collapse: initial;
  border-spacing: initial;
}


.my-custom-scrollbar {
  max-height: 90%;
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.ref-select {
  display: flex;
}

.ref-select>p,
.ref-select select {
  margin: 0;
  font-size: 0.85rem;
}

.ref-select select {
  height: 25px;
  padding: 1px 5px;
  min-width: 140px;
}

.referenceInfoYear {
  font-size: 0.85rem;
  color: #ff5f00;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  text-align: center;
}

.yearText {
  margin: 0;
  margin-top: 2px !important;
}

.select-view {
  min-width: 100px;
}

@media only screen and (max-width: 810px) {
  .inputFileGroup {
    max-width: 300px;
  }

  .ConfigContainer {
    width: 100%;
  }
}
</style>
